export enum InspectionStatus {
  Created = "1",
  Pending = "2",
  Contacted = "3",
  Solved = "4",
  Finished = "5",
}
